import * as actionTypes from "./actionTypes";

// Load Product List
export const mallLoadProductList = (id, data = {}, listType = "") => {
  return {
    type: actionTypes.MALL_LOAD_PRODUCT_LIST,
    id,
    data,
    listType
  };
};

export const mallLoadProductListSuccess = (data, listType) => {
  return {
    type: actionTypes.MALL_LOAD_PRODUCT_LIST_SUCCESS,
    data,
    listType
  };
};

export const mallLoadProductListFail = () => {
  return {
    type: actionTypes.MALL_LOAD_PRODUCT_LIST_FAIL
  };
};
// END Load Product List

// Get Product Detail
export const mallGetProductDetail = (shopID, productID) => {
  return {
    type: actionTypes.MALL_GET_PRODUCT_DETAIL,
    shopID,
    productID
  };
};

export const mallGetProductDetailSuccess = data => {
  return {
    type: actionTypes.MALL_GET_PRODUCT_DETAIL_SUCCESS,
    data
  };
};

export const mallGetProductDetailFail = () => {
  return {
    type: actionTypes.MALL_GET_PRODUCT_DETAIL_FAIL
  };
};
// END Get Product Detail
